<section>
  <mat-icon>error_outline</mat-icon>
  <h3>No results found</h3>
</section>
